export const GOOGLE_OAUTH_CLIENT_ID = "799934358315-8a677t2mrpg56po2okc9jkqa4sgucju2.apps.googleusercontent.com";

export const USER_TYPES = {
  FAMILY: "family",
  PROVIDER: "provider",
  ADMIN: "admin",
};

export const DOCUMENT_OWNER_TYPES = {
  USER: "U",
  ADMIN: "S",
};

export const focusAreas = [
  {
    label: "Early Learners",
    value: "Early Learners",
  },
  {
    label: "School-Aged",
    value: "School-Aged",
  },
  {
    label: "Play-Based Therapy",
    value: "Play-Based Therapy",
  },
  {
    label: "Structured Therapy",
    value: "Structured Therapy",
  },
  {
    label: "Communication Skills",
    value: "Communication Skills",
  },
  {
    label: "AAC Support",
    value: "AAC Support",
  },
  {
    label: "Social Skills",
    value: "Social Skills",
  },
  {
    label: "Emotional Regulation",
    value: "Emotional Regulation",
  },
  {
    label: "Challenging Behavior Support",
    value: "Challenging Behavior Support",
  },
  {
    label: "Daily Living Skills",
    value: "Daily Living Skills",
  },
  {
    label: "Parent Coaching",
    value: "Parent Coaching",
  },
  {
    label: "Skill Generalization",
    value: "Skill Generalization",
  },
  {
    label: "Community-Based Services",
    value: "Community-Based Services",
  },
  {
    label: "School Collaboration",
    value: "School Collaboration",
  },
  {
    label: "Trauma-Informed Care",
    value: "Trauma-Informed Care",
  },
  {
    label: "Sleep Routines",
    value: "Sleep Routines",
  },
  {
    label: "Feeding and Mealtime Skills",
    value: "Feeding and Mealtime Skills",
  },
  {
    label: "School Readiness",
    value: "School Readiness",
  },
  {
    label: "Assent-Based Practice",
    value: "Assent-Based Practice",
  },
  {
    label: "Toileting and Self-Care Skills",
    value: "Toileting and Self-Care Skills",
  },
];

export const acceptedInsurances = [
  {
    label: "Aetna (Commercial)",
    value: "Aetna",
    states: ["Indiana", "Georgia", "Texas", "Arizona", "North Carolina"],
  },
  {
    label: "Anthem / Blue Cross Blue Shield (Commercial)",
    value: "Anthem Blue Cross Blue Shield",
    states: ["Indiana", "Georgia", "North Carolina"],
  },
  {
    label: "Cigna / Evernorth (Commercial)",
    value: "Evernorth Cigna",
    states: ["Indiana", "Georgia", "North Carolina"],
  },
  {
    label: "United / Optum (Commercial)",
    value: "Optum United Healthcare",
    states: ["Indiana", "Georgia", "North Carolina"],
  },
  {
    label: "PHP / Encore (Commercial)",
    value: "Physicians Health Plan",
    states: ["Indiana"],
  },
  {
    label: "Indiana State Medicaid",
    value: "Medicaid",
    states: ["Indiana"],
  },
  {
    label: "MDWise (Medicaid)",
    value: "MDwise Medicaid",
    states: ["Indiana"],
  },
  {
    label: "MHS (Medicaid)",
    value: "Managed Health Services Medicaid",
    states: ["Indiana"],
  },
  {
    label: "Caresource (Medicaid)",
    value: "Caresource IN Medicaid",
    states: ["Indiana"],
  },
  {
    label: "Anthem / Blue Cross Blue Shield (Medicaid)",
    value: "Anthem Medicaid",
    states: ["Indiana"],
  },
  {
    label: "Children's Special Health Care Services / CSHCS",
    value: "CSHCS",
    states: ["Indiana"],
  },

  // Georgia specific
  {
    label: "Georgia State Medicaid",
    value: "Georgia State Medicaid",
    states: ["Georgia"],
  },
  {
    label: "Peach State Health Plan (Medicaid)",
    value: "Peach State GA Medicaid",
    states: ["Georgia"],
  },
  {
    label: "Caresource (Medicaid)",
    value: "Caresource GA Medicaid",
    states: ["Georgia"],
  },
  {
    label: "Amerigroup (Medicaid)",
    value: "Amerigroup GA Medicaid",
    states: ["Georgia"],
  },

  // Texas specific
  {
    label: "Aetna Better Health",
    value: "Aetna Better Health",
    states: ["Texas"],
  },
  {
    label: "Amerigroup",
    value: "Amerigroup",
    states: ["Texas"],
  },
  {
    label: "BCBS TX (Commercial/Medicaid)",
    value: "BCBS TX Commercial Medicaid",
    states: ["Texas"],
  },
  {
    label: "Community Health Choice",
    value: "Community Health Choice",
    states: ["Texas"],
  },
  {
    label: "Cooks Children",
    value: "Cooks Children",
    states: ["Texas"],
  },
  {
    label: "Evernorth",
    value: "Evernorth",
    states: ["Texas", "Arizona"],
  },
  {
    label: "Molina",
    value: "Molina",
    states: ["Texas", "Arizona"],
  },
  {
    label: "Optum",
    value: "Optum",
    states: ["Texas", "Arizona"],
  },
  {
    label: "Parkland",
    value: "Parkland",
    states: ["Texas"],
  },
  {
    label: "Superior",
    value: "Superior",
    states: ["Texas"],
  },
  {
    label: "Tricare",
    value: "Tricare",
    states: ["Texas"],
  },
  {
    label: "Texas Childrens",
    value: "Texas Childrens",
    states: ["Texas"],
  },
  {
    label: "TMHP-TX Medicaid",
    value: "TMHP-TX Medicaid",
    states: ["Texas"],
  },

  // Arizona specific
  {
    label: "AZ Medicaid",
    value: "AZ Medicaid",
    states: ["Arizona"],
  },
  {
    label: "Banner Health",
    value: "Banner Health",
    states: ["Arizona"],
  },
  {
    label: "BCBS AZ",
    value: "BCBS AZ",
    states: ["Arizona"],
  },
  {
    label: "Carefirst (Medicaid)",
    value: "Carefirst Medicaid",
    states: ["Arizona"],
  },
  {
    label: "Complete Health",
    value: "Complete Health",
    states: ["Arizona"],
  },
  {
    label: "Health Choice",
    value: "Health Choice",
    states: ["Arizona"],
  },
  {
    label: "Mercy Care",
    value: "Mercy Care",
    states: ["Arizona"],
  },

  // North Carolina specific
  {
    label: "Medcost",
    value: "Medcost",
    states: ["North Carolina"],
  },
  {
    label: "Alliance (Medicaid)",
    value: "Alliance",
    states: ["North Carolina"],
  },
  {
    label: "Amerihealth (Medicaid)",
    value: "Amerihealth",
    states: ["North Carolina"],
  },
  {
    label: "Healthy Blue (Medicaid)",
    value: "Healthy Blue NC",
    states: ["North Carolina"],
  },
  {
    label: "North Carolina State Medicaid",
    value: "NC Medicaid",
    states: ["North Carolina"],
  },
  {
    label: "Partners (Medicaid)",
    value: "Partners",
    states: ["North Carolina"],
  },
  {
    label: "Trillium (Medicaid)",
    value: "Trillium",
    states: ["North Carolina"],
  },
  {
    label: "Vaya (Medicaid)",
    value: "Vaya",
    states: ["North Carolina"],
  },
  {
    label: "Wellcare (Medicaid)",
    value: "Wellcare",
    states: ["North Carolina"],
  },
  {
    label: "Carolina Complete (Medicaid)",
    value: "Carolina Complete",
    states: ["North Carolina"],
  },
].sort((a, b) => a.label.localeCompare(b.label));

export const siteOfCareOptions = [
  {
    label: "In Home",
    value: "In Home",
  },
  {
    label: "In Clinic",
    value: "In Clinic",
  },
];

export const languages = [
  {
    label: "English",
    value: "English",
  },
  {
    label: "Spanish",
    value: "Spanish",
  },
  {
    label: "Mandarin Chinese",
    value: "Mandarin Chinese",
  },
  {
    label: "Cantonese",
    value: "Cantonese",
  },
  {
    label: "Tagalog",
    value: "Tagalog",
  },
  {
    label: "Vietnamese",
    value: "Vietnamese",
  },
  {
    label: "Arabic",
    value: "Arabic",
  },
  {
    label: "French",
    value: "French",
  },
  {
    label: "Korean",
    value: "Korean",
  },
  {
    label: "Russian",
    value: "Russian",
  },
  {
    label: "German",
    value: "German",
  },
  {
    label: "Haitian Creole",
    value: "Haitian Creole",
  },
  {
    label: "Hindi",
    value: "Hindi",
  },
  {
    label: "Portuguese",
    value: "Portuguese",
  },
  {
    label: "Italian",
    value: "Italian",
  },
  {
    label: "Polish",
    value: "Polish",
  },
  {
    label: "Japanese",
    value: "Japanese",
  },
  {
    label: "Urdu",
    value: "Urdu",
  },
  {
    label: "Gujarati",
    value: "Gujarati",
  },
  {
    label: "Bengali",
    value: "Bengali",
  },
  {
    label: "American Sign Language (ASL)",
    value: "American Sign Language",
  },
].sort((a, b) => a.label.localeCompare(b.label));
